import { z } from "zod";

export const createGroupSchema = z.object({
	name: z.string().min(1).max(100),
	description: z.string().max(500).optional(),
	photo_url: z.url().optional(),
});

export type CreateGroupPayload = z.infer<typeof createGroupSchema>;
